module.exports = __webpack_public_path__ + "static/media/total-orders.4e4fcd24.svg";